import React, { useState } from "react";
import { executeCode, fetchResult } from "../../utils/executeCode";
import CodeEditorWindow from "./CodeEditorWindow";
import CodeMirror from "@uiw/react-codemirror";

const CodeEditor = () => {
  const [code, setCode] = useState("// Write your code here...");
  const [output, setOutput] = useState("");
  const [language, setLanguage] = useState("python3");

  const handleRun = async () => {
    const result = await executeCode(code, language);
    setOutput(result);
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-2">React Code Editor</h2>

      {/* Language Selector */}
      <select
        className="mb-2 p-2 border rounded"
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
      >
        <option value="python3">Python</option>
        <option value="javascript">JavaScript</option>
        <option value="cpp">C++</option>
        <option value="java">Java</option>
      </select>

      {/* Code Editor */}
      <CodeMirror value={code} height="200px" onChange={setCode} />

      {/* Run Button */}
      <button
        className="mt-2 bg-blue-500 text-white p-2 rounded"
        onClick={handleRun}
      >
        Run Code
      </button>

      {/* Output Section */}
      <div className="mt-4 p-2 bg-gray-100 rounded">
        <h3 className="font-bold">Output:</h3>
        <pre>{output}</pre>
      </div>
    </div>
  );
};

export default CodeEditor;
